
var id = "dl";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 529.8 65.6\" id=\"dl\">\n<style type=\"text/css\">\n\t#dl .st0{fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M62.8,32.8c0,19.4-14.2,32.5-35.2,32.5H0.3v-65h28C48.9,0.4,62.8,13.5,62.8,32.8z M45.5,33\n\t\tc0-11.2-7.3-18.8-17.6-18.8H17.2v37.5h11.5C38.6,51.6,45.5,44.1,45.5,33z\" />\n\t<path class=\"st0\" d=\"M112.8,53.8H84.7l-4.5,11.5H62.8l27.9-65h17.4l27.3,65h-18.1L112.8,53.8z M107.8,40.9l-8.9-23.2l-9.1,23.2\n\t\tC89.8,40.9,107.8,40.9,107.8,40.9z\" />\n\t<path class=\"st0\" d=\"M184.3,0.4v14h-19.5v51h-17v-51h-19.3v-14H184.3z\" />\n\t<path class=\"st0\" d=\"M227.5,53.8h-28.1l-4.5,11.5h-17.4l27.9-65h17.4l27.3,65h-18.1L227.5,53.8z M222.4,40.9l-8.9-23.2l-9.1,23.2\n\t\tH222.4z\" />\n\t<path class=\"st0\" d=\"M300.6,0.4v50.5h27.5v14.5h-44.5v-65H300.6z\" />\n\t<path class=\"st0\" d=\"M379.4,53.8h-28.1l-4.5,11.5h-17.4l27.9-65h17.4l27.3,65h-18.1L379.4,53.8z M374.4,40.9l-8.9-23.2l-9.1,23.2\n\t\tH374.4z\" />\n\t<path class=\"st0\" d=\"M449.9,65.3L433,40.2l-8.3,9.3v15.9h-17v-65h17v27.3l24.4-27.3h19.7l-24.1,26.9l25.6,38.1H449.9z\" />\n\t<path class=\"st0\" d=\"M528.4,0.4v13.5h-34.3V26h31v13.4l-31,0.1v12.2h35.2v13.5h-52.2v-65H528.4z\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
